import { Modal } from "antd";
import { FC } from "react";

import BaseButton from "@/components/BaseButton";
import { PrimaryText } from "@/components/Typography/Styled";

import { StyledConfirmButton, StyledDangerIcon } from "./Styled";
import { WarningProps } from "./warning.interface";

export const WarningModal: FC<WarningProps> = ({
    modalKey,
    isModalOpened,
    confirm,
    cancel,
    width,
    title = "Ви впевнені?",
    children,
    maskClosable = true,
    isLoadingConfirm = false,
    isVisibleAlarm = true,
}) => {
    const visibleAlarm = isVisibleAlarm;
    return (
        <Modal
            key={modalKey}
            open={isModalOpened}
            onOk={() => confirm?.()}
            onCancel={() => cancel()}
            centered
            footer={[]}
            width={width}
            maskClosable={maskClosable}
        >
            {visibleAlarm ? <StyledDangerIcon /> : <></>}
            <PrimaryText
                fontSize={20}
                fontWeight="500"
                style={{ textAlign: "center", marginBottom: 16 }}
            >
                {title}
            </PrimaryText>
            {children}

            {confirm && (
                <StyledConfirmButton
                    type="primary"
                    onClick={() => confirm()}
                    loading={isLoadingConfirm}
                >
                    Підтвердити
                </StyledConfirmButton>
            )}

            <BaseButton
                type="default"
                onClick={() => cancel()}
                marginTop="16px"
            >
                Повернутися назад
            </BaseButton>
        </Modal>
    );
};
